import React, { useEffect, useRef, useState } from "react";
import { Card, CardBody, Button, Typography, Input, Popover, PopoverHandler } from "@material-tailwind/react";
import { BiSolidShow } from "react-icons/bi";
import { FaEyeSlash } from "react-icons/fa";
import { forgotUserPassword, loginUsers, registerUsers } from "../../api";
import { Bounce, toast, ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "../layout/Layout.module.css";
import { messages } from "../../utils/constantMessages";
import TermsOfUsePopover from "./TermsOfUsePopover";
import GoogleAuthLogin from "./GoogleAuthLogin";
import LinkedInLogin from "./LinkedInLogin";
import { APP_NAME } from "../../utils/appConstant";
const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
let user_data = {
  email: "",
  name: "",
  mentee_id: "",
  login_type: ""
};
type RegisterPageProps = {
  userName: string;
  setUserName: (name: string) => void;

  emailIdForRegistration: string;
  emailValid: boolean;
  handleRegisterEmailChange: (e: React.ChangeEvent<HTMLInputElement>) => void;

  showErrorMessageAfterRegister: string;
  showMessageAfterRegister: boolean;

  handleCheckboxClicked: () => void;
  termsAndPolicyChecked: boolean;

  handleRegister: () => void;

  isPopoverOpen: boolean;
  setIsPopoverOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setType: (type: string) => void;
};

const RegisterPage: React.FC<RegisterPageProps> = ({
  userName,
  setUserName,
  emailIdForRegistration,
  emailValid,
  handleRegisterEmailChange,
  showErrorMessageAfterRegister,
  showMessageAfterRegister,
  handleCheckboxClicked,
  termsAndPolicyChecked,
  handleRegister,
  isPopoverOpen,
  setIsPopoverOpen,
  setType
}) => {
  showErrorMessageAfterRegister;
  return (
    //
    <form className="flex flex-col sm:h-[50vh]   overflow-auto justify-between" autoComplete="off">
      <div className="flex flex-col gap-4">
        {/* Name Input */}
        <div className="px-1">
          <Typography variant="small" color="blue-gray" className="mb-2 font-bold">
            Your Name <span className="text-red-800">*</span>
          </Typography>
          <Input
            type="text"
            placeholder="Enter your name"
            className="w-full p-3 rounded-md outline-1"
            autoFocus
            value={userName}
            onChange={e => setUserName(e.target.value)}
          />
        </div>

        {/* Email Input */}
        <div className="px-1">
          <Typography variant="small" color="blue-gray" className="mb-2 font-bold">
            Your Email <span className="text-red-800">*</span>
          </Typography>
          <Input
            type="email"
            placeholder="name@mail.com"
            className="w-full p-3 rounded-md outline-1"
            autoFocus
            value={emailIdForRegistration}
            onChange={handleRegisterEmailChange}
          />
          {!emailValid && (
            <p className="mt-1 text-sm text-red-600">
              Please enter a valid email address (e.g., <span className="text-blue-600">&nbsp;user@example.com</span> ).
            </p>
          )}
        </div>

        {/* Error / Success Messages */}
        {showErrorMessageAfterRegister && (
          <div className="relative ml-2 text-sm h-[10] overflow-y-auto text-red-600 ">{showErrorMessageAfterRegister}.</div>
        )}
        {showMessageAfterRegister && (
          <div className="relative text-sm h-[10] overflow-y-auto text-green-800 ">
            Your password has been sent to your email. Please check your inbox or spam folder and use it to log in.
          </div>
        )}
      </div>

      {/* <div className="flex-grow"></div> */}

      {/* Checkbox + Register Button */}
      <div className="bottom-0">
        <div className=" mt-2">
          <div>
            <input type="checkbox" className="cursor-pointer" onClick={handleCheckboxClicked} checked={termsAndPolicyChecked} /> I agree to
            the{" "}
            <Popover open={isPopoverOpen} handler={() => setIsPopoverOpen(!isPopoverOpen)}>
              <PopoverHandler>
                <span className="text-blue-700 cursor-pointer">terms of use and privacy policy</span>
              </PopoverHandler>
              <TermsOfUsePopover isPopoverOpen={setIsPopoverOpen} setIsPopoverOpen={setIsPopoverOpen} />
            </Popover>
            {"."}
          </div>
          {/* <div className="flex-grow"></div> */}
          <div className="flex justify-center p-1">
            <Button
              size="lg"
              className="mt-auto bg-slate-700 w-[50vh] p-3"
              onClick={handleRegister}
              disabled={emailIdForRegistration === "" || userName === "" || !termsAndPolicyChecked}
            >
              Register
            </Button>
          </div>
        </div>
        {/* 👇 Back to Login link */}
        <div className="flex justify-center ">
          <p>
            Already have an account?{" "}
            <span onClick={() => setType("login")} className="text-blue-600 cursor-pointer">
              Login
            </span>
          </p>
        </div>
      </div>
    </form>
  );
};

type LoginPageProps = {
  loginEmail: string;
  password: string;
  showPassword: boolean;
  isLoginEmailValid: boolean;
  isReadAble: boolean;
  isForgotPasswordClicked: boolean;

  handleLoginEmailChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleLoginPasswordChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handlePasswordKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  handleLogin: () => void;

  handleForgotPasswordClick: () => void;
  SetShowPassWord: React.Dispatch<React.SetStateAction<boolean>>;
  setType: (type: string) => void;
};

const LoginPage: React.FC<LoginPageProps> = ({
  loginEmail,
  password,
  showPassword,
  isLoginEmailValid,
  isReadAble,
  isForgotPasswordClicked,
  handleLoginEmailChange,
  handleLoginPasswordChange,
  handlePasswordKeyDown,
  handleLogin,
  handleForgotPasswordClick,
  SetShowPassWord,
  setType
}) => {
  return (
    <>
      {!isForgotPasswordClicked && (
        <div className="sm:h-[50vh] w-full overflow-x-hidden overflow-y-auto">
          <div className=" w-full flex sm:pt-20 pb-8">
            <div className="flex justify-center w-full ">
              <div className=" flex flex-col  sm:flex-row  gap-8  pb-3 overflow-x-auto">
                <GoogleAuthLogin />
                <LinkedInLogin></LinkedInLogin>
              </div>
            </div>
          </div>
          <div className="flex items-center justify-center gap-3 bottom-0 w-full ">
            <div className="w-full h-px bg-gray-500 shadow-2xl opacity-50 duration-200 ease-in-out " />
            <span className="text-sm text-gray-500 font-medium">OR</span>
            <div className="w-full h-px bg-gray-500 shadow-2xl opacity-50 duration-200 ease-in-out " />
          </div>
          <div className="flex flex-col  py-8 ">
            <form className=" flex flex-col flex-grow overflow-auto justify-start">
              <div className="flex flex-col gap-4">
                {/* Email */}
                <div className="px-1">
                  <Typography variant="small" color="blue-gray" className="mb-2 font-bold">
                    Your Email <span className="text-red-800">*</span>
                  </Typography>
                  <Input
                    type="email"
                    placeholder="name@mail.com"
                    className="w-full p-3 rounded-md outline-1"
                    value={loginEmail}
                    autoFocus
                    onChange={handleLoginEmailChange}
                    autoComplete="off"
                    readOnly={isReadAble}
                  />
                  {!isLoginEmailValid && (
                    <p className="mt-1 text-sm text-red-600">
                      Please enter a valid email address (e.g., <span className="text-blue-400">&nbsp;user@example.com</span> ).
                    </p>
                  )}
                </div>

                {/* Password */}
                <div className="px-1">
                  <Typography variant="small" color="blue-gray" className="mb-2 font-bold">
                    Password <span className="text-red-800">*</span>
                  </Typography>
                  <div className="relative">
                    <Input
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your password"
                      className="w-full p-3 rounded-md pr-8 outline-1"
                      value={password}
                      autoComplete="off"
                      onChange={handleLoginPasswordChange}
                      onKeyDown={handlePasswordKeyDown}
                    />
                    {showPassword ? (
                      <FaEyeSlash
                        className="absolute w-5 h-5 top-2.5 right-2.5 text-slate-600 cursor-pointer"
                        onClick={() => SetShowPassWord(false)}
                      />
                    ) : (
                      <BiSolidShow
                        className="absolute w-5 h-5 top-2.5 right-2.5 text-slate-600 cursor-pointer"
                        onClick={() => SetShowPassWord(true)}
                      />
                    )}

                    {/* Forgot Password Link */}
                    <div className="text-right text-sm cursor-pointer relative pt-2">
                      <span onClick={handleForgotPasswordClick} className="inset-0 z-10 text-blue-600 text-right">
                        Forgot Password?
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex-grow"></div>
              <div className="flex justify-center p-1 pt-5 ">
                <Button
                  size="lg"
                  className="mt-auto bg-slate-700 w-[50vh] p-3"
                  onClick={handleLogin}
                  disabled={loginEmail === "" || password === ""}
                >
                  Login
                </Button>
              </div>

              <div className="flex justify-center ">
                <p>
                  Don't have an account?{" "}
                  <span onClick={() => setType("register")} className="text-blue-600 cursor-pointer">
                    Register
                  </span>
                </p>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

type ForgotPasswordPageProps = {
  emailForForgotPassword: string;
  isForgotEmailValid: boolean;
  showMessageAfterForgotPassword: boolean;
  handleEmailForForgotPasswordChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleForgotPasswordSubmit: () => void;
  handleForgotPasswordClick: () => void;
  showErrorMessageAfterForgotPassword: string;
};

const ForgotPasswordPage: React.FC<ForgotPasswordPageProps> = ({
  emailForForgotPassword,
  isForgotEmailValid,
  showMessageAfterForgotPassword,
  handleEmailForForgotPasswordChange,
  handleForgotPasswordSubmit,
  handleForgotPasswordClick,
  showErrorMessageAfterForgotPassword
}) => {
  return (
    <form className="flex flex-col sm:h-[50vh] py-6">
      {/* Instruction */}
      <div className="flex flex-col">
        <Typography variant="small" color="blue-gray" className="mb-4 font-bold border-none">
          Please enter your registered email address <span className="text-red-800">*</span>
        </Typography>

        {/* Email input */}
        <Input
          type="email"
          placeholder="name@mail.com"
          className="w-full p-3 rounded-md outline-1"
          value={emailForForgotPassword}
          onChange={handleEmailForForgotPasswordChange}
        />
        {!isForgotEmailValid && (
          <p className="mt-1 text-sm text-red-600">
            Please enter a valid email address (e.g., <span className="text-blue-600">&nbsp;user@example.com</span> ).
          </p>
        )}
      </div>

      {/* Success message */}
      {showMessageAfterForgotPassword && (
        <div className="my-1 text-sm overflow-auto text-green-800">
          Your password has been sent to your email. Please check your inbox or spam folder and use the password to log in.
        </div>
      )}
      {/* Error */}
      {showErrorMessageAfterForgotPassword && (
        <div className="my-1 text-sm  overflow-y-auto text-red-600 ">{showErrorMessageAfterForgotPassword}</div>
      )}
      {/* Actions */}
      <div className="flex justify-end mt-4 gap-4">
        <div className="relative">
          <Button
            className="bg-slate-700 text-white p-3 rounded-lg"
            onClick={handleForgotPasswordSubmit}
            disabled={emailForForgotPassword === ""}
          >
            Submit
          </Button>
        </div>
        <div className="relative">
          <Button className="bg-slate-700 text-white p-3 rounded-lg" onClick={handleForgotPasswordClick}>
            Back to Login
          </Button>
        </div>
      </div>

      <div className="w-[50vw]"></div>
    </form>
  );
};

function UserLoginPage() {
  const [isForgotPasswordClicked, setIsForgotPasswordClicked] = useState(false);
  const [showPassword, SetShowPassWord] = useState(false);
  const [emailIdForRegistration, setEmailIdForRegistration] = useState("");
  const [emailValid, setEmailValid] = useState(true); // New state for email validity
  const [isLoginEmailValid, setIsLoginEmailValid] = useState(true); // New state for email validity
  const [userName, setUserName] = useState("");
  const [emailForForgotPassword, setEmailForForgotPassword] = useState("");
  const [, setGetRegisterRes] = useState("");
  const [, setShowRegistrationResponse] = useState(false);
  const [isForgotEmailValid, setIsForgotEmailValid] = useState(true);
  const [loginEmail, setLoginEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [termsAndPolicyChecked, setTermsAndPolicyChecked] = useState(false);
  const location = useLocation();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const isSaving = useRef(false);
  const [showMessageAfterRegister, setShowMessageAfterRegister] = useState(false);
  const [doesUserHasUniqueLink, setDoesUserHasUniqueLink] = useState(false);
  const [showErrorMessageAfterRegister, setShowErrorMessageAfterRegister] = useState("");
  const [showMessageAfterForgotPassword, setShowMessageAfterForgotPassword] = useState(false);
  const [showErrorMessageAfterForgotPassword, setShowErrorMessageAfterForgotPassword] = useState("");

  const [type, setType] = React.useState("login");
  const [isReadAble, setIsReadAble] = useState(false);
  useEffect(() => {
    if (location?.state?.errorMessage) {
      toast.error(location.state.errorMessage, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light"
      });
    }
  }, [location]);

  useEffect(() => {
    if (location?.state?.participant_email) {
      setLoginEmail(location.state.participant_email || "");
      //   setType("login");
      setIsReadAble(true);
      if (location?.state?.user_exist === "no") {
        //  showToast(location?.state?.password);
        // setShowSentPasswordMessageComingViaURL(true);
      } else {
        // setShowSentPasswordMessageComingViaURL(false);
        // setShowNoteMessageComingViaURLIfUserExists(true);
      }
    }
  }, [location]);
  let registerRes: any;
  const notifyError = (errorMassage: string) => {
    toast.error(errorMassage, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      transition: Bounce,
      theme: "light"
      //   transition: Slide,
      //   style: { backgroundColor: "rgb(30 41 59)" },
    });
  };

  const handleRegister = async () => {
    if (isSaving.current) return; // Prevent multiple rapid clicks

    // isSaving.current = true;
    setEmailValid(emailRegex.test(emailIdForRegistration));

    if (userName !== "" && emailIdForRegistration !== "" && emailIdForRegistration !== null && emailRegex.test(emailIdForRegistration)) {
      isSaving.current = true; // Set flag only when API call is about to start

      try {
        registerRes = await registerUsers(userName, emailIdForRegistration);
        const registerData = registerRes.data;
        setShowRegistrationResponse(true);
        if (registerData.user_exist) {
          setDoesUserHasUniqueLink(true);
          setIsReadAble(true);
          setLoginEmail(registerData.participant_email);
        } else {
          setShowMessageAfterRegister(true);
          setIsReadAble(false);
          setShowErrorMessageAfterRegister("");
        }
        setGetRegisterRes(registerData.mail_message);
      } catch (error: any) {
        isSaving.current = false;
        setShowMessageAfterRegister(false);
        if (error.response.status === 400) {
          setShowErrorMessageAfterRegister(error.response.data.message);
        } else {
          toast.error("Registration Failed", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            // theme: "dark",
            transition: Bounce
          });
        }
      } finally {
        isSaving.current = false; // Reset flag immediately after success or failure
      }
    }
  };
  const onClose = () => {
    setDoesUserHasUniqueLink(false);
    setType("login");
    setTermsAndPolicyChecked(false);
  };
  const handleLogin = async () => {
    if (isSaving.current) return; // Prevent multiple rapid clicks
    setIsLoginEmailValid(emailRegex.test(loginEmail));
    if (loginEmail !== "" && loginEmail !== null && emailRegex.test(loginEmail)) {
      isSaving.current = true; // Set flag only when API call is about to start
      try {
        const loginRes = await loginUsers(loginEmail, password);
        const loginData = loginRes.data;

        setGetRegisterRes(loginData);
        user_data.email = loginRes.data.email;
        user_data.name = loginRes.data.name;
        user_data.mentee_id = loginRes.data.mentee_id;
        user_data.login_type = loginRes.data.login_type;
        const maintenance = loginRes.data.m;
        localStorage.setItem("mentee_data", JSON.stringify(user_data));
        navigate("/", { state: { maintenance } });
      } catch (error: any) {
        isSaving.current = false;
        if (error.response.status === 500) {
          toast.error("Login Failed", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            // theme: "dark",
            transition: Bounce
          });
        } else notifyError(error.response.data.message);
      } finally {
        isSaving.current = false;
      }
    }
  };
  const handleForgotPasswordSubmit = async () => {
    setIsForgotEmailValid(emailRegex.test(emailForForgotPassword));
    try {
      if (emailForForgotPassword !== "" && emailForForgotPassword !== null && emailRegex.test(emailForForgotPassword)) {
        const forgotUserPasswordRes = await forgotUserPassword(emailForForgotPassword);
        forgotUserPasswordRes.data;
        // showToast(forgotUserPasswordData.mail_message);
        setShowMessageAfterForgotPassword(true);
        setEmailForForgotPassword("");
        setShowErrorMessageAfterForgotPassword("");
        // setIsForgotPasswordClicked(false);
      }
    } catch (error: any) {
      setShowMessageAfterForgotPassword(false);
      console.log("error: ", error);
      if (error.status === 400) {
        // notifyError(error.response.data.message);
        setShowErrorMessageAfterForgotPassword(error.response.data.message);
      } else if (error.status === 500) {
        notifyError(messages.UNEXPECTED_ERROR_OCCURRED);
      }
    }
  };
  const handleEmailForForgotPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const email = e.target.value;
    setEmailForForgotPassword(email.toLowerCase());
    setIsForgotEmailValid(true);
  };
  const handleLoginEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const email = e.target.value;
    setLoginEmail(email.toLowerCase());
    setIsLoginEmailValid(true);
  };
  const handleLoginPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const password = e.target.value;

    setPassword(password);
  };
  const handlePasswordKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };
  const handleCheckboxClicked = () => {
    setTermsAndPolicyChecked(!termsAndPolicyChecked);
  };
  const handleRegisterEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const email = e.target.value;
    setEmailIdForRegistration(email.toLowerCase());
    setEmailValid(true);
  };
  const handleForgotPasswordClick = () => {
    setEmailForForgotPassword("");
    setIsForgotPasswordClicked(!isForgotPasswordClicked);
    setShowMessageAfterForgotPassword(false);
    setShowErrorMessageAfterForgotPassword("");
  };

  return (
    <div className="h-full">
      <div className="w-full">
        <header className={`${styles.header} top-0 z-50 w-full shadow-lg`} role={"banner"}>
          <div className={`${styles.headerContainer} h-16`}>
            <div className={styles.headerTitleContainer}>
              <h3 className={styles.headerTitle}>{APP_NAME}</h3>
            </div>
            <div className={`${styles.headerRightText} flex items-center pl-2 h-14 gap-2 rounded-lg`}>
              <div className="min-w-16">
                <a href="https://www.pm-powerconsulting.com/" target="_blank">
                  <img src="/PM_POWER_LOGO_WHITE-2019.png" className="justify-self-end h-10" />
                </a>
              </div>
            </div>
          </div>
        </header>
      </div>
      <div className="flex min-h-0 flex-col h-[92vh] items-center justify-start overflow-y-auto px-4 pb-4 pt-4 sm:justify-center sm:overflow-visible sm:p-4 sm:pt-2">
        {doesUserHasUniqueLink ? (
          <div className="flex justify-center items-center h-full">
            <dialog open className="w-11/12 md:w-5/12 shadow-lg z-50 p-3 border rounded-xl">
              <div className="overflow-auto">
                <div className="text-md overflow-auto text-green-800 mb-4">
                  We have made some updates to improve your login experience. We have sent you an email with your new login credentials. To
                  access your content, use the credentials provided in the email to log into{" "}
                  <a onClick={onClose} className="text-blue-500 font-bold cursor-pointer">
                    powerguide.ai
                  </a>
                  .
                </div>
                <div className="text-sm overflow-auto text-green-800 mb-4">
                  <span className="font-bold">Note:</span> Your account has already been set up, and all your data has been securely
                  migrated. If you have trouble finding the email or need assistance, please contact us at{" "}
                  <span className="font-medium">info@pm-powerconsulting.com</span>.
                </div>
                <div className="text-green-800">
                  Please review{" "}
                  <Popover open={isPopoverOpen} handler={() => setIsPopoverOpen(!isPopoverOpen)}>
                    <PopoverHandler>
                      <span className="text-blue-700 cursor-pointer">terms of use and privacy policy</span>
                    </PopoverHandler>
                    <TermsOfUsePopover isPopoverOpen={setIsPopoverOpen} setIsPopoverOpen={setIsPopoverOpen}></TermsOfUsePopover>
                  </Popover>
                  {"."}
                </div>
              </div>
              <form method="dialog" className="flex justify-center pt-2">
                <button onClick={onClose} className="bg-slate-700 text-white rounded-md px-2 py-1">
                  Continue
                </button>
              </form>
            </dialog>
            <ToastContainer />
          </div>
        ) : (
          <div className="flex min-w-0 w-full max-w-full flex-col bg-white rounded-xl sm:h-[57vh] sm:w-[57vw] sm:flex-row md:w-[57vw]">
            <div className="flex   h-full p-2 sm:w-1/2">
              <div className="flex flex-col items-center h-full text-center">
                {/* w-[80%] max-w-[200px] sm:w-[20vw] sm:mb-2 */}
                <img
                  src="/PowerGuide logo with name white bg-2.png"
                  alt="Logo"
                  className="mx-auto h-auto w-auto max-w-none shrink-0 max-h-[min(18vh,10rem)] sm:mb-2 sm:max-h-[min(20vh,12rem)]"
                />
                <div className="overflow-y-auto">
                  <p className="text-sm sm:text-base text-gray-700 text-center">
                    <span className="font-bold block text-base sm:text-lg my-2">
                      Welcome to {APP_NAME}, a new way of learning and growing!
                    </span>
                    <span className="flex-wrap">
                      {APP_NAME} leverages the power of Gen AI to tap into exclusive PM Power curated content. It will provide you with
                      contextual responses to your queries instantly.
                    </span>
                    <br />
                    <br />
                    <span>
                      Responses are based on key insights from PM Power blogs, exclusive content, books and curated podcasts distilled from
                      1000+ person years of leadership and delivery experience. Citations used in formulating a response are made available
                      for your reference to promote in-depth learning.
                    </span>
                  </p>
                </div>
                <div className="flex-grow"></div>
                <div>
                  {" "}
                  <p className="text-xs text-slate-500 mt-2 bottom-0">
                    <span className="font-bold">Important:</span> Responses from {APP_NAME} AI may be partial or sometimes inaccurate.
                    Please use your discretion.
                  </p>
                </div>
              </div>
            </div>
            <div className="flex items-center h-full w-full sm:w-1/2 mt-4 sm:mt-0">
              <Card className="w-full rounded-xl h-full p-1">
                <CardBody className="h-full">
                  {type === "login" && (
                    <LoginPage
                      loginEmail={loginEmail}
                      password={password}
                      showPassword={showPassword}
                      isLoginEmailValid={isLoginEmailValid}
                      isReadAble={isReadAble}
                      isForgotPasswordClicked={isForgotPasswordClicked}
                      handleLoginEmailChange={handleLoginEmailChange}
                      handleLoginPasswordChange={handleLoginPasswordChange}
                      handlePasswordKeyDown={handlePasswordKeyDown}
                      handleLogin={handleLogin}
                      handleForgotPasswordClick={handleForgotPasswordClick}
                      SetShowPassWord={SetShowPassWord}
                      setType={setType}
                    />
                  )}
                  {type === "login" && isForgotPasswordClicked && (
                    <ForgotPasswordPage
                      emailForForgotPassword={emailForForgotPassword}
                      isForgotEmailValid={isForgotEmailValid}
                      showMessageAfterForgotPassword={showMessageAfterForgotPassword}
                      handleEmailForForgotPasswordChange={handleEmailForForgotPasswordChange}
                      handleForgotPasswordSubmit={handleForgotPasswordSubmit}
                      handleForgotPasswordClick={handleForgotPasswordClick}
                      showErrorMessageAfterForgotPassword={showErrorMessageAfterForgotPassword}
                    />
                  )}
                  {type === "register" && (
                    <RegisterPage
                      userName={userName}
                      setUserName={setUserName}
                      emailIdForRegistration={emailIdForRegistration}
                      emailValid={emailValid}
                      handleRegisterEmailChange={handleRegisterEmailChange}
                      showErrorMessageAfterRegister={showErrorMessageAfterRegister}
                      showMessageAfterRegister={showMessageAfterRegister}
                      handleCheckboxClicked={handleCheckboxClicked}
                      termsAndPolicyChecked={termsAndPolicyChecked}
                      handleRegister={handleRegister}
                      isPopoverOpen={isPopoverOpen}
                      setIsPopoverOpen={setIsPopoverOpen}
                      setType={setType}
                    />
                  )}
                </CardBody>
              </Card>
            </div>
          </div>
        )}
        <ToastContainer />
      </div>
    </div>
  );
}

export default UserLoginPage;
